import React, {Component} from 'react';
import RedirectUrisTable from "./RedirectUrisTable";
import {PropTypes} from 'prop-types';
import * as messageConstants from '../../../shared/messages';

class RedirectUris extends Component {
  static propTypes = {
    oidcRedirectUris: PropTypes.any,
    capabilitiesMappingId: PropTypes.string,
    handleAddOidcRedirectUri: PropTypes.func,
    handleDelOidcRedirectUri: PropTypes.func,
    handleUpdateOidcRedirectUri: PropTypes.func,
  }

  handleAddEvent = () => {
    this.props.handleAddOidcRedirectUri();
  }
  handleDelEvent = (target) => {
    this.props.handleDelOidcRedirectUri(target);
  }
  handleUpdateEvent = (evt) => {
    this.props.handleUpdateOidcRedirectUri(evt);
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
        <div className="pt-31">
          <p className="sba-subtitle">
            {messageConstants.OIDC_URI_TITLE}
          </p>
          &nbsp;
          <div className="add-edit-subtitle">
            {messageConstants.OIDC_URI_SUBTITLE}
          </div>
          <RedirectUrisTable
              onOidcRedirectUrisUpdate={this.handleUpdateEvent}
              onRowAdd={this.handleAddEvent}
              onRowDel={this.handleDelEvent}
              oidcRedirectUris={this.props.oidcRedirectUris}/>
        </div>
    );
  }
}

export default RedirectUris;





// WEBPACK FOOTER //
// ./src/components/OidcApp/RedirectUris/RedirectUris.js